<div class="fullcontainer" >

  <br />
  <br />

  <div class='titleContainer'>
    <h2 class='header' style='color:#006598;'>Financial exports (retired)</h2>
  </div>

  <!-- The Generate Batch form has been removed, not hidden. It built a Sage file from every invoice
       on a date and recorded nothing about which documents were in it, so re-running it posted the
       same invoices to Sage a second time. The grid below stays because these files are the only
       record of what was sent to Sage before the changeover. -->
  <div class='sheet'>
    <p>
      Sage exports are no longer generated here. This screen is kept so the files produced before the
      changeover remain available &mdash; they are the only record of what was sent to Sage at the
      time.
    </p>
    <p>
      To send invoices and credit notes to Sage, use
      <a [routerLink]='"/invoices/sage-export"'>Sage Export</a>. Unlike this screen, it records every
      document it sends and treats nothing as reaching Sage until somebody confirms the import.
    </p>
    <a class='btn btn-primary' [routerLink]='"/invoices/sage-export"'>Go to Sage Export</a>
  </div>

  <br />
  <br />

  <app-grid
entity='batch'
[filters]='this.filters'
[columns]='this.columns'
[buttons]='this.buttons'
[searchFilters]='this.searchFilters'
[searchFields]='this.searchFields'
></app-grid>
